module.exports = __webpack_public_path__ + "img/face-3.fa54d3ea.jpg";